import React, { useEffect } from 'react';
import { useUnit } from 'hooks/units/index';

import { UNIT_TYPE_COMPLETE } from 'constants/constants';

import TimeComplete from './TimeComplete';
import CheckboxComplete from './CheckboxComplete';
import QuestionComplete from './QuestionComplete/QuestionComplete';
import AssigmentComplete from './AssigmentComplete/AssigmentComplete';

const Complete = (props) => {
  const unitSelected = useUnit();

  const renderTypeComplete = () => {
    if (unitSelected?.complete?.type === UNIT_TYPE_COMPLETE.TIME) {
      return <TimeComplete />;
    }

    if (unitSelected?.complete?.type === UNIT_TYPE_COMPLETE.CHECKBOX) {
      return <CheckboxComplete setIntervalId={props.setIntervalId} />;
    }

    if (unitSelected?.complete?.type === UNIT_TYPE_COMPLETE.QUESTION) {
      return <QuestionComplete setIntervalId={props.setIntervalId} />;
    }

    if (
      unitSelected?.complete?.type === UNIT_TYPE_COMPLETE.UPLOADING_ANSWER ||
      unitSelected?.complete?.type === UNIT_TYPE_COMPLETE.INSTRUCTOR_ACCEPT ||
      unitSelected?.complete?.type === UNIT_TYPE_COMPLETE.AIAccept
    ) {
      return <AssigmentComplete />;
    }
  };

  if (!unitSelected) return null;

  return <div>{renderTypeComplete()}</div>;
};

export default Complete;
